<form *ngIf="fascicoloPctForm" [formGroup]="fascicoloPctForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div labelTextInput class="col-sm-6 bloccodati"
      [typeLabel]="'text'"
      [labelInput]="'Numero Ruolo'"
      [valueInput]="fascicoloPct.numeroRuolo"></div>
    <div labelTextInput class="col-sm-6 bloccodati"
      [typeLabel]="'text'"
      [labelInput]="'Anno Ruolo'"
      [valueInput]="fascicoloPct.annoRuolo"></div>
  </div>
  <div class="row">
    <div comboModInput class="col-sm-6"
      formControlName="registro"
      [labelInput]="'Registro'"
      [mandatory]="true"
      [optionsCombo]="registroOptions"
      [objectReference]="registroValue"
      (onReturn)="onChangeRegistroSel($event)">
    </div>
    <div comboModInput class="col-sm-6"
      formControlName="delegante"
      [labelInput]="'Delegante'"
      [optionsCombo]="deleganteOptions"
      [objectReference]="deleganteValue"
      (onReturn)="onChangeDeleganteSel($event)">
    </div>
  </div>
  <div class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" aria-label="Reset" class="btn btn-outline-secondary btn-block"
        (click)="createForm()">Reset</button>
    </p>
    <p submitButton
      class="col-sm-3 col-xs-6 col-sm-offset-6"
      [labelButton]="'Salva'"
      [disabled]="!fascicoloPctForm || !fascicoloPctForm.valid"></p>
  </div>
</form>
